export default (coll, value) => coll.indexOf(value) > -1;
